import React,{useState} from "react";
/* import { Redirect } from "react-router-dom";
import { getCookieIShare } from "../api/user";
import { Cookies } from "react-cookie";
import { KEYROCK_TOKEN } from "../utils/constants";
import { getIdp } from "../api/auth"; */
import Logo from "../assets/img/png/logo-white.png";
import banderaEn from "../assets/img/jpg/en.jpg";
import banderaEs from "../assets/img/png/es.png";
import LogoUE from "../assets/img/jpg/logo_FondoEuropeo.jpg";
import logoGobAragon from "../assets/img/jpg/logo_GobiernoAragon.jpg";
import {useTranslation} from 'react-i18next';
import { basePath, apiVersion } from "../api/config";

import "./Home.scss";
import i18n from "../i18n";

import Popup from "../components/pupUp/pupUp";
import {useLanguage} from "../hooks"

//var isEs = false;

export default function Home() {
 const{language,setLanguage,isEs,setIsEs}=useLanguage();
  /* capillar.it
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let code = params.get("code");

  var idp = getIdp();
  getCookieIShare(code, idp).then((res) => {
    localStorage.setItem(KEYROCK_TOKEN, res);
   //console.log(res);
    window.location.href = "/admin/login";
  }); */
  



  // const {t} = useTranslation();
  // const [language,setLanguage]=useState('en');

  // const onChangeLanguage=()=>{
  //  //console.log(basePath)
  //   i18n.changeLanguage(language);
  //   if(language==='es'){
  //     isEs = false;
  //     setLanguage('en');
  //   } else{
  //     isEs = true;
  //     setLanguage('es');
  //   }
  // }

  const onChangeLanguage=()=>{
    i18n.changeLanguage(language);
    if(language==='es'){
      setIsEs(false);
      setLanguage('en');
    } else{
      setIsEs(true);
      setLanguage('es');
    }
  }

  return (
    <div className="home">
      <div className="homeback">
        <div className="homeback-up">
            <a href="/" className="homeback-up-pictureAndLogo-logo">
              <img src={Logo} alt="logo" />
            </a>
            <a href="/admin/login" className="button" >
                {i18n['t']('home.initSesion')}
            </a>
        </div>
        <div className="homeback-down">
            <Popup
              titulo={'ffff'}
              contenido={'sdfsfsdf s fsfsf'}
            >
            </Popup>
           <button onClick={onChangeLanguage} className="buttonBandera"> 
            <img src={isEs?banderaEs:banderaEn} alt="bandera" />
          </button>
          
        </div>
      </div>
      <div className="description">
        <h1 className="description-title">
        {i18n['t']('home.title')}
        </h1>
        <h1 className="description-subtitle">
        {i18n['t']('home.subtitle')} 
        </h1>
        <div className='contacto'>
          <h1 className="contacto-knowMore">
          {i18n['t']('home.knowMore')}
          </h1>
          <a href="/contact" className="contacto-button" >
          {i18n['t']('home.contact')}
          </a>
        </div>
      </div>
      <div className="white">
        <h1 className="white-title">
        {i18n['t']('home.our')}
        </h1>
        <h1 className="white-middle">
        {i18n['t']('home.textTitle')}
        </h1>
        <h1 className="white-end1">
        {i18n['t']('home.textsubTitle1')} 
          </h1>
        <h1 className="white-end2">
        {i18n['t']('home.textsubTitle2')}
          </h1>
        <h1 className="white-end3">
        {i18n['t']('home.textsubTitle3')}
        </h1>
      </div>
      <div className="brown">
          <h1 className="brown-logoGobAragon">
            <img src={logoGobAragon} alt="logoGobAragon" />
          </h1>
          <h1 className="brown-logoUE">
            <img src={LogoUE} alt="logoUE" />
          </h1>
      </div>
      <div className="black">
          <h1 className="black-init">
          {i18n['t']('home.web')} 
          </h1>
          <h1 className="black-end">
            2022
          </h1>
      </div>
      
    </div>
  );
}

